/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { FormattedMessage, useIntl } from 'react-intl'
import { useParams } from 'react-router'
import PageTitle from '../../../../client/js/components/PageTitle'
import { fetchIntervention } from '../../lib/rest/interventionAPIClient'
import InterventionForm from './InterventionForm'
import { useQuery } from '@tanstack/react-query'
import LoadingHelper from '../../../../client/js/components/LoadingHelper'
import { Card, Container } from '@mantine/core'
import { parseNumber } from '@jalik/form-parser'
import useParsedQueryParam from '../../../../client/js/hooks/useParsedQueryParam'
import useQueryParams from '../../../../client/js/hooks/useQueryParams'
import Page from '../../../../client/js/components/Page'
import BreadcrumbCard from '../../../../client/js/components/breadcrumb/BreadcrumbCard'
import AdminBreadcrumb from '../../../../client/js/components/breadcrumb/AdminBreadcrumb'
import AnchorLink from '../../../../client/js/components/AnchorLink'
import { getInterventionListLink } from '../../lib/links/interventionLinks'

function InterventionFormPage () {
  const intl = useIntl()
  const params = useParams<{ id?: string }>()
  const interventionId = parseInt(params.id, 10)
  const [searchParams] = useQueryParams()
  const estateId = useParsedQueryParam('estateId', parseNumber)
  const leaseId = useParsedQueryParam('leaseId', parseNumber)

  const interventionQuery = useQuery({
    enabled: true,
    queryKey: ['intervention', interventionId, searchParams],
    queryFn: () => interventionId > 0
      ? fetchIntervention(interventionId)
      : Promise.resolve({
        estateId,
        leaseId
      } as Partial<Intervention>),
    refetchOnWindowFocus: false
  })
  const { data } = interventionQuery

  const title = interventionId > 0 && data != null
    ? data.subject
    : intl.formatMessage({
      id: 'create_intervention',
      defaultMessage: 'Créer une intervention'
    })

  return (
    <Page>
      <Container size="xl">
        <PageTitle
          hidden
          title={title}
        />

        <BreadcrumbCard>
          <AdminBreadcrumb>
            <AnchorLink to={getInterventionListLink()}>
              <FormattedMessage
                id="interventions"
                defaultMessage="Interventions"
              />
            </AnchorLink>
            <span>{title}</span>
          </AdminBreadcrumb>
        </BreadcrumbCard>

        <Card shadow="sm">
          <LoadingHelper
            query={interventionQuery}
            render={() => (
              <InterventionForm initialValues={data} />
            )}
          />
        </Card>
      </Container>
    </Page>
  )
}

export default InterventionFormPage
